import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import { Autocomplete, Skeleton } from "@material-ui/lab";
import { useQuery } from "@tanstack/react-query";
import { TextField } from "@material-ui/core";
import { fetchNotibuzones } from "../../../../shared/fetchers/classics/notibuzon/verNotibuzon";
import CrearNotibuzonIndividual from "../crear-notibuzon/crear-notibuzon-individual";

const EditarNotibuzon = () => {
  const [notibuzon, setNotibuzon] = useState(null);

  const {
    data: notibuzones,
    isLoading,
    isError,
  } = useQuery(["notibuzones"], fetchNotibuzones);

  if (isLoading)
    return (
      <>
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
      </>
    );

  if (isError)
    return <div>Ha ocurrido un error, prueba recargando la página</div>;

  return (
    <>
      <div className="mb-4 d-flex align-items-center">
        <div className="admin-page-tilte">(</div>
        <CreateOutlinedIcon />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">Editar un notibuzón</div>
      </div>
      <Container fluid>
        <Row>
          <Col xs={12} className="content-white-box px-4 py-4">
            <label className="admin-label-text mt-3 d-block">
              Selecciona un notibuzón para editarlo
            </label>
            <Autocomplete
              options={notibuzones}
              value={notibuzon}
              disabled={Boolean(notibuzon)}
              getOptionLabel={(option) =>
                `${option.idNotibuzon} - ${option?.metadatos?.titulo.es ?? "SIN TITULO"}`
              }
              onChange={(_, newValue) => {
                setNotibuzon(newValue);
              }}
              noOptionsText="Sin resultados"
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  style={{
                    width: "100%",
                    fontFamily: "'Noto Sans JP', sans-serif",
                  }}
                />
              )}
            />
          </Col>

          {notibuzon && (
            <CrearNotibuzonIndividual
              notibuzon={{ ...notibuzon }}
              clearEdit={() => {
                setNotibuzon(null);
              }}
            />
          )}
        </Row>
      </Container>
    </>
  );
};

export default EditarNotibuzon;
